/* eslint-disable react/prop-types */
import { Component } from "react";
import { Alert, Badge, Button, Card, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";

import historicoClinicoService from "../../api/atendimentos/historicoClinicoService";
import { formataDataHoraExibicao, tiposDocumentoHistoricoClinico } from "../../common/utils";

class HistoricoClinicoAtendimento extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            salvando: false,
            enviandoDocumento: false,
            erro: "",
            registros: [],
            showModal: false,
            formulario: this.getFormularioInicial(),
            showModalDocumento: false,
            formDocumento: { historico_id: null, tipo: "prescricao", descricao: "", arquivo: null },
        };
    }

    componentDidMount() {
        this.carregar();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.atendimentoId !== this.props.atendimentoId) {
            this.carregar();
        }
    }

    getFormularioInicial = () => ({
        historico_resumido: "",
        sintomas_atuais: "",
        sinais_alerta: "",
    });

    getMensagemErro = (error, fallback) => {
        const data = error?.response?.data;

        if (typeof data === "string" && data.trim()) {
            return data;
        }

        if (data && typeof data === "object") {
            const primeiraChave = Object.keys(data)[0];
            const primeiroValor = data[primeiraChave];

            if (Array.isArray(primeiroValor) && primeiroValor.length > 0) {
                return primeiroValor[0];
            }

            if (typeof primeiroValor === "string" && primeiroValor.trim()) {
                return primeiroValor;
            }
        }

        return fallback;
    };

    carregar = async () => {
        const { atendimentoId } = this.props;

        if (!atendimentoId) {
            this.setState({ loading: false, registros: [] });
            return;
        }

        this.setState({ loading: true, erro: "" });

        try {
            const response = await historicoClinicoService.listar(atendimentoId);
            const data = response.data || {};

            this.setState({
                loading: false,
                registros: Array.isArray(data.resultados) ? data.resultados : [],
            });
        } catch (error) {
            console.error("Erro ao carregar histórico clínico:", error);
            this.setState({
                loading: false,
                erro: this.getMensagemErro(error, "Não foi possível carregar o histórico clínico."),
            });
        }
    };

    abrirModal = () => this.setState({ showModal: true, formulario: this.getFormularioInicial() });

    fecharModal = () => this.setState({ showModal: false, formulario: this.getFormularioInicial() });

    onChangeFormulario = (event) => {
        const { name, value } = event.target;
        this.setState((estado) => ({ formulario: { ...estado.formulario, [name]: value } }));
    };

    salvar = async () => {
        const { atendimentoId } = this.props;
        const { formulario } = this.state;

        const preenchido =
            formulario.historico_resumido.trim() ||
            formulario.sintomas_atuais.trim() ||
            formulario.sinais_alerta.trim();

        if (!preenchido) {
            Swal.fire(
                "Atenção",
                "Preencha ao menos um dos campos: histórico clínico resumido, sintomas atuais ou sinais de alerta.",
                "warning"
            );
            return;
        }

        const confirmacao = await Swal.fire({
            title: "Confirmar registro?",
            text: "Após salvo, o conteúdo do histórico clínico não poderá ser editado nem removido.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sim, registrar",
            cancelButtonText: "Revisar",
        });

        if (!confirmacao.isConfirmed) {
            return;
        }

        this.setState({ salvando: true });

        try {
            await historicoClinicoService.create({
                atendimento_id: atendimentoId,
                historico_resumido: formulario.historico_resumido.trim(),
                sintomas_atuais: formulario.sintomas_atuais.trim(),
                sinais_alerta: formulario.sinais_alerta.trim(),
            });

            this.setState({ salvando: false, showModal: false, formulario: this.getFormularioInicial() });
            await this.carregar();
            Swal.fire("Sucesso", "Histórico clínico registrado com sucesso.", "success");
        } catch (error) {
            console.error("Erro ao registrar histórico clínico:", error);
            this.setState({ salvando: false });
            Swal.fire("Erro", this.getMensagemErro(error, "Não foi possível registrar o histórico clínico."), "error");
        }
    };

    abrirModalDocumento = (historicoId) => {
        this.setState({
            showModalDocumento: true,
            formDocumento: { historico_id: historicoId, tipo: "prescricao", descricao: "", arquivo: null },
        });
    };

    fecharModalDocumento = () => this.setState({ showModalDocumento: false });

    onChangeDocumento = (event) => {
        const { name, value, files } = event.target;
        this.setState((estado) => ({
            formDocumento: { ...estado.formDocumento, [name]: files ? files[0] : value },
        }));
    };

    enviarDocumento = async () => {
        const { formDocumento } = this.state;

        if (!formDocumento.arquivo) {
            Swal.fire("Atenção", "Selecione o arquivo.", "warning");
            return;
        }

        if (formDocumento.tipo === "outro" && !formDocumento.descricao.trim()) {
            Swal.fire("Atenção", 'A descrição complementar é obrigatória quando o tipo do documento é "Outro".', "warning");
            return;
        }

        this.setState({ enviandoDocumento: true });

        try {
            await historicoClinicoService.enviarDocumento(
                formDocumento.historico_id,
                formDocumento.tipo,
                formDocumento.descricao.trim(),
                formDocumento.arquivo
            );

            this.setState({ enviandoDocumento: false, showModalDocumento: false });
            await this.carregar();
            Swal.fire("Sucesso", "Documento anexado com sucesso.", "success");
        } catch (error) {
            console.error("Erro ao anexar documento ao histórico clínico:", error);
            this.setState({ enviandoDocumento: false });
            Swal.fire("Erro", this.getMensagemErro(error, "Não foi possível anexar o documento."), "error");
        }
    };

    renderCampo = (titulo, conteudo) => {
        if (!conteudo) {
            return null;
        }

        return (
            <Col sm={12} className="mb-3">
                <small className="text-muted d-block">{titulo}</small>
                <span style={{ whiteSpace: "pre-wrap" }}>{conteudo}</span>
            </Col>
        );
    };

    renderDocumentos = (registro) => {
        const documentos = registro.documentos || [];

        if (documentos.length === 0) {
            return <span className="text-muted">Nenhum documento anexado.</span>;
        }

        return (
            <ul className="list-unstyled mb-0">
                {documentos.map((documento) => (
                    <li key={documento.id} className="mb-1">
                        <Badge bg="secondary" className="me-2">
                            {tiposDocumentoHistoricoClinico[documento.tipo] || documento.tipo_display}
                        </Badge>
                        {documento.arquivo_url ? (
                            <a href={documento.arquivo_url} target="_blank" rel="noreferrer">
                                {documento.nome_original || "Abrir documento"}
                            </a>
                        ) : (
                            <span>{documento.nome_original || "-"}</span>
                        )}
                        {documento.descricao && <span className="text-muted"> — {documento.descricao}</span>}
                        {documento.data_criacao && (
                            <small className="text-muted"> ({formataDataHoraExibicao(documento.data_criacao)})</small>
                        )}
                    </li>
                ))}
            </ul>
        );
    };

    renderRegistro = (registro) => {
        const { podeEditar } = this.props;

        return (
            <Card className="cardDestaque mt-3" key={registro.id}>
                <Card.Body>
                    <Row className="align-items-center mb-2">
                        <Col sm={8}>
                            <small className="text-muted">
                                Registrado por <strong>{registro.usuario_nome || "-"}</strong>
                                {registro.data_criacao && ` em ${formataDataHoraExibicao(registro.data_criacao)}`}
                            </small>
                        </Col>
                        <Col sm={4} className="text-end">
                            {podeEditar && (
                                <Button variant="outline-primary" size="sm" onClick={() => this.abrirModalDocumento(registro.id)}>
                                    Anexar documento
                                </Button>
                            )}
                        </Col>
                    </Row>
                    <Row>
                        {this.renderCampo("Histórico clínico resumido", registro.historico_resumido)}
                        {this.renderCampo("Sintomas atuais", registro.sintomas_atuais)}
                        {this.renderCampo("Sinais de alerta", registro.sinais_alerta)}
                        <Col sm={12}>
                            <small className="text-muted d-block">Documentos</small>
                            {this.renderDocumentos(registro)}
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        );
    };

    renderModalRegistro = () => {
        const { showModal, formulario, salvando } = this.state;

        return (
            <Modal show={showModal} onHide={this.fecharModal} size="lg" backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>Registrar histórico clínico</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Alert variant="warning">
                        Após o salvamento o conteúdo <strong>não poderá ser editado nem removido</strong>. Para atualizar
                        as informações, registre um novo histórico.
                    </Alert>
                    <Form.Label>Histórico clínico resumido</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={4}
                        className="mb-3"
                        name="historico_resumido"
                        value={formulario.historico_resumido}
                        onChange={this.onChangeFormulario}
                    />
                    <Form.Label>Sintomas atuais</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={3}
                        className="mb-3"
                        name="sintomas_atuais"
                        value={formulario.sintomas_atuais}
                        onChange={this.onChangeFormulario}
                    />
                    <Form.Label>Sinais de alerta</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={3}
                        name="sinais_alerta"
                        value={formulario.sinais_alerta}
                        onChange={this.onChangeFormulario}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.fecharModal} disabled={salvando}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={this.salvar} disabled={salvando}>
                        {salvando ? "Salvando..." : "Salvar"}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    };

    renderModalDocumento = () => {
        const { showModalDocumento, formDocumento, enviandoDocumento } = this.state;

        return (
            <Modal show={showModalDocumento} onHide={this.fecharModalDocumento} backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>Anexar documento</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Label>Classificação do documento *</Form.Label>
                    <Form.Select className="mb-3" name="tipo" value={formDocumento.tipo} onChange={this.onChangeDocumento}>
                        {Object.entries(tiposDocumentoHistoricoClinico).map(([valor, label]) => (
                            <option key={valor} value={valor}>
                                {label}
                            </option>
                        ))}
                    </Form.Select>
                    {formDocumento.tipo === "outro" && (
                        <>
                            <Form.Label>Descrição complementar *</Form.Label>
                            <Form.Control
                                className="mb-3"
                                name="descricao"
                                value={formDocumento.descricao}
                                onChange={this.onChangeDocumento}
                            />
                        </>
                    )}
                    <Form.Label>Arquivo *</Form.Label>
                    <Form.Control type="file" name="arquivo" onChange={this.onChangeDocumento} />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.fecharModalDocumento} disabled={enviandoDocumento}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={this.enviarDocumento} disabled={enviandoDocumento}>
                        {enviandoDocumento ? "Enviando..." : "Anexar"}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    };

    render() {
        const { podeEditar } = this.props;
        const { loading, erro, registros } = this.state;

        if (loading) {
            return (
                <div className="text-center mt-4">
                    <Spinner animation="border" />
                </div>
            );
        }

        if (erro) {
            return (
                <Alert variant="danger" className="mt-4">
                    {erro}
                </Alert>
            );
        }

        return (
            <>
                <Card className="cardDestaque mt-4">
                    <Card.Body>
                        <Row className="align-items-center">
                            <Col sm={8}>
                                <h5 className="mb-1">Histórico Clínico</h5>
                                <small className="text-muted">
                                    Os registros são imutáveis. Para atualizar as informações, adicione um novo registro.
                                </small>
                            </Col>
                            <Col sm={4} className="text-end">
                                {podeEditar && (
                                    <Button variant="outline-primary" size="sm" onClick={this.abrirModal}>
                                        Adicionar registro
                                    </Button>
                                )}
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>

                {registros.length === 0 ? (
                    <Alert variant="light" className="mt-3 text-center">
                        Nenhum histórico clínico registrado até o momento.
                    </Alert>
                ) : (
                    registros.map((registro) => this.renderRegistro(registro))
                )}

                {this.renderModalRegistro()}
                {this.renderModalDocumento()}
            </>
        );
    }
}

export default HistoricoClinicoAtendimento;
